
import Http from './Http'

export default {
    async getMatchMotm(match_id) {
        return await Http.get(`/games/motm/match/${match_id}/all`)
    },
    async getMatchScorePrediction(match_id) {
        // return await Http.get(`/games/gts/match/${match_id}`)  this route doesn't exsist
        return await Http.get(`/games/gts/match/${match_id}/all`)
    },
    async getMatchMotmData(match_id, data='') {
        return await Http.get(`/games/motm/${match_id}?${data}`)
    },
    async exportMotmData(match_id,data) {
        return await Http.get(`/games/motm/match/${match_id}/export` , data)
    },
    async saveMOTMvotes(match_id, data){
        return await Http.post(`/games/motm/adminvotes/${match_id}`, data)
    },
    async getLeaderboardData(data) {
        return await Http.get(`/games/leaderboard?${data}`)
    },
    async getLeaderboardDataSetup(data) {
        return await Http.get(`/games/leaderboard/setup?${data}`)
    },
    async getLeaderboardMiniSetup() {
        return await Http.get(`/games/leaderboard/mini/setup`)
    },
    async getLeaderboardMini(data) {
        return await Http.get(`/games/leaderboard/mini?${data}`)
    },
    async getScorePrediction(customer_id, data) {
        return await Http.get(`/games/gts/customer/${customer_id}`, data);
    },
    async getCurrentMatches(data) {
        return await Http.get(`/football/matches/current`, data);
    },
    async getAllWords(data) {
        return await Http.get(`/games/word/all?${data}`)
    },
    async getWordStats(params = {}) {
        const searchParams = new URLSearchParams(params).toString();
        return await Http.get(`/games/word/stats?${searchParams}`);
    },
    async deleteWord(language, word) {
        return await Http.delete(`/games/word/${language}/${word}`)
    },
    async uploadWords(data){
        return await Http.post(`/games/word/upload`, data)
    },
    async getMatchesMonthly(data) {
        return await Http.get(`/games/motm/monthly/${data}`)
    },
    async exportToExcel(month) {
        return await Http.get(`/games/motm/monthly/${month}/export`)
    },
    async getPolls(data) {
        return await Http.get(`/games/poll?${data}`)
    },
    async deletePoll(id) {
        return await Http.delete(`/games/poll/question/${id}`)
    },
    async deletePollAnswer(id) {
        return await Http.delete(`/games/poll/answer/${id}`)
    },
    async addPoll(data) {
        return await Http.post(`/games/poll/question`,data,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    async editPoll(pollId,data) {
        return await Http.post(`/games/poll/question/${pollId}`,data,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    async addAnswer(data) {
        return await Http.post(`/games/poll/answer`,data)
    },
    async editQuizAnswer(data) {
        return await Http.patch(`/games/quiz/answer`,data)
    },
    async editQuizQuestionTranslation(data) {
        return await Http.patch(`/games/quiz/translateQuestion`,data)
    },
    async getQuizQuestion(data) {
        return await Http.get(`/games/quiz?${data}`)
    },
    async getQuizBulkApprovalQueue(params = '') {
        const q = params ? `?${params}` : ''
        return await Http.get(`/games/quiz/bulkApprovalQueue${q}`)
    },
    async addQuizQuestion(data) {
        return await Http.post(`/games/quiz/question`,data,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    async editQuizQuestion(question_id, data) {
        return await Http.post(`/games/quiz/question/${question_id}`,data,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    async deleteQuizQuestion(question_id) {
        return await Http.delete(`/games/quiz/question/${question_id}`)
    },
    async getReviewedImages(data = '') {
        return await Http.get(`/games/quiz/getReviewedImages?${data}`)
    },
    async approveReviewedImage(data) {
        return await Http.post(`/games/quiz/approveReviewedImage`, data)
    },
    async getReviewedQuestions(data = '') {
        return await Http.get(`/games/quiz/getReviewedQuestions?${data}`)
    },
    async addImageToReview( data,) {
        return await Http.post(`/games/quiz/reviewImage`, data)
    },
    async updateMiniGamesStreak(data) {
        return await Http.patch(`/games/mini/streak`, data)
    },
    async getMiniGamesStreakCalendar(game_id, customer_id, date_from = '', date_to = '') {
        const params = {
            game_id,
            customer_id,
        };

        if (date_from) params.date_from = date_from;
        if (date_to) params.date_to = date_to;

        const searchParams = new URLSearchParams(params).toString();
        return await Http.get(`/games/mini/streak?${searchParams}`)
    },
}


